/**
 * @generated SignedSource<<fcd33cab08f18cf00bb9b2785dabe250>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewInRoomImage_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useItemDisplayDimensions_user">;
  readonly " $fragmentType": "ViewInRoomImage_user";
};
export type ViewInRoomImage_user$key = {
  readonly " $data"?: ViewInRoomImage_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoomImage_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoomImage_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemDisplayDimensions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "351b95c399923fa03648a92b56a10101";

export default node;
